<div class="recap-tables">
    <div>
        <p class="recap-label">Situazione Attuale</p>

        <app-assets-table
            [assets]="currentFunds"
            [form]="form"
            [tableKeys]="tableKeys"
            [isReadOnly]="true"
        ></app-assets-table>
    </div>

    <div>
        <p class="recap-label">Nuova Attribuzione</p>

        <app-assets-table
            [assets]="policyFunds"
            [form]="form"
            [tableKeys]="tableKeys"
            [isReadOnly]="isReadOnly"
        ></app-assets-table>
    </div>
</div>
